
  import React from "react"
  import Component from "/Users/dylan/personal-website/src/layouts/index.jsx"
  import data from "/Users/dylan/personal-website/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js